
import { createContext, useContext, useMemo } from "react";
import { useDocument } from "react-firebase-hooks/firestore";
import { doc } from "firebase/firestore";
import db from "../firebase";
import { UserAuth } from "./AuthContext";

export const UserLayoutContext = createContext();

export function UserLayoutProvider({ children }) {
  const { user } = UserAuth();
  const layoutDocRef = user ? doc(db, `user_layout/${user.uid}`) : null;
  
  const [layoutDocSnapshot, loading, error] = useDocument(layoutDocRef);

  const value = useMemo(() => {
    const layoutData = layoutDocSnapshot?.data() || {};
    return {
      layoutData,
      loading,
      error,
    };
  }, [layoutDocSnapshot, loading, error]);

  return (
    <UserLayoutContext.Provider value={value}>
      {children}
    </UserLayoutContext.Provider>
  );
}

export const useUserLayout = () => {
  return useContext(UserLayoutContext);
};